import {  Component,
  OnDestroy,
  OnInit,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ApplicationRef,
  AfterViewInit,
  ViewChild,
  HostListener,
  Injector } from '@angular/core';
import { AppComponentBase } from "../../services/AppComponentBase";
import { MainUIServiceService } from '../../services/main-uiservice.service';

@Component({
  selector: 'app-root',
  template: require('./app-root.component.html'),
  styles: [require('./app-root.component.scss')]
})
export class AppRootComponent extends AppComponentBase implements OnDestroy, OnInit, AfterViewInit {

  constructor( 

    injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object,
    private mainUIService:MainUIServiceService)

   {
    super(injector)
   

    setTimeout(() => {
      this.workspace.AppTick();
  }, 100);
//  this.workspace.AppTick();

   }

  ngOnInit() {
   
  }

  private _itemInfo = "123";
  public get itemInfo () {
    return this._itemInfo;
  }
  public set itemInfo ( value ) {
    this._itemInfo = value;
  }

  public get mobileModeAppRoot():string
  {
    return this.workspace.mobileMode;
  }

  ngAfterViewInit(): void {
   
  }

  ngOnDestroy(): void {
  }
}
